/* eslint-disable react/no-array-index-key */
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './ColumnMenu.styles';
import Link from './Link';

const RecursiveMenuEntry = (props) => {
  const classes = useStyles(props);
  const { children, navLinks } = props;
  return (
    <li key={children}>
      {children && <Link {...props} classes={classes}>{children}</Link>}
      {navLinks && (
      <ul>
          {navLinks.map((link, index) => (<RecursiveMenuEntry key={`${link.children}-${index}`} {...link} />))}
      </ul>
      )}
    </li>
  );
};

const ColumnMenu = (props) => {
  const { navLinks } = props;
  const classes = useStyles(props);
  return (
    <ul className={classes.root}>
      {navLinks.map((link, index) => (<RecursiveMenuEntry key={`${link.children}-${index}`} {...link} />))}
    </ul>
  );
};

RecursiveMenuEntry.propTypes = {
  children: PropTypes.node,
  navLinks: PropTypes.arrayOf(PropTypes.object)
};

RecursiveMenuEntry.defaultProps = {
  children: undefined,
  navLinks: null
};

ColumnMenu.propTypes = {
  navLinks: PropTypes.arrayOf(PropTypes.shape({
    /** typically a string, but can also be provided as a component */
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    /** custom component to override the default sub menu component */
    menu: PropTypes.node,
    /** custom component rendered imediately after the children */
    footer: PropTypes.node,
    /** callback after clicked.  */
    onClick: PropTypes.func,
    /** used on top nav tabs. visual seperator of links. useful when links are images */
    divider: PropTypes.bool,
    /** display icon indicating child navLinks. required for setting styles correctly */
    hasIcon: PropTypes.bool,
    /** render children as plain markup instead of a button */
    isHeader: PropTypes.bool,
    /** toggle relative position of tabs so that sub menus can be styled */
    relativePosition: PropTypes.bool,
    /** toggle if tab receives background shading on hover.
     * typically used in combination with custom children components */
    shadeOnHover: PropTypes.bool,
    /** link href. not used if link is a parent of navLinks */
    href: PropTypes.string
  })).isRequired
};

export default ColumnMenu;
